module.exports = __webpack_public_path__ + "img/galgal_yes.73e77f18.png";